// extracted by mini-css-extract-plugin
module.exports = {"releaseNotes":"style_releaseNotes__1N8wa","notify":"style_notify__uhY3g"};